import { render, staticRenderFns } from "./CoachSlider.vue?vue&type=template&id=7b07265a&scoped=true"
import script from "./CoachSlider.vue?vue&type=script&lang=js"
export * from "./CoachSlider.vue?vue&type=script&lang=js"
import style0 from "./CoachSlider.vue?vue&type=style&index=0&id=7b07265a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b07265a",
  null
  
)

export default component.exports